import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';

// ══════════════════════════════════════════════
//  RoleGuard — Fogón v9
//  Protege rutas según rol del usuario.
//  Uso en routing:
//    { path: 'config', canActivate: [RoleGuard],
//      data: { roles: ['ADMI', 'SADM'] } }
//
//  Si no se especifica data.roles, solo permite ADMI.
// ══════════════════════════════════════════════

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const userRole = sessionStorage.getItem('idRole') || '';

    // Obtener roles permitidos de la data de la ruta
    const allowedRoles: string[] = route.data['roles'] || ['ADMI'];

    if (userRole && allowedRoles.includes(userRole)) {
      return true;
    }

    // Sin acceso: redirigir según contexto
    if (!userRole) {
      // El idCompany ya no se propaga por URL (cliente fijo COMPANY001).
      this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
    } else if (userRole === 'SYSA') {
      // SYSA solo puede estar en /business/companies
      this.router.navigate(['/business/companies']);
    } else {
      this.router.navigate(['/dashboard']);
    }

    return false;
  }
}
